import { FC } from 'react';
import { Share } from 'lucide-react';
import { Button } from '@repo/ui/components/ui/button';
import { useCandidates } from '../../../../../../../apps/web/src/state';
import { permissions as permifyPermissions } from '../../../../../../api/src/permify/constants';
import { ConfirmationDialog } from '@repo/ui/components/ui/confirmation-dialog';

export type ExportCandidatesProps = {
  candidateIds: string[];
  className?: string;
  variant?:
    | 'default'
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | 'link';
};

const BULK_QUANTITY = 50;

export const ExportCandidates: FC<ExportCandidatesProps> = ({
  className,
  variant = 'default',
  candidateIds,
}) => {
  const { contactExport } = useCandidates();
  const action = () => contactExport(candidateIds);
  const permission = permifyPermissions.openCalls.bulkAction;
  const trigger = (
    <Button
      variant={variant}
      data-permission={permission}
      className={className}
      disabled={candidateIds.length === 0}
      onClick={candidateIds.length <= BULK_QUANTITY ? action : undefined}
    >
      Contact
      <Share />
    </Button>
  );
  return (
    <>
      {candidateIds.length <= BULK_QUANTITY && trigger}
      {candidateIds.length > BULK_QUANTITY && (
        <ConfirmationDialog
          title="Export contact data?"
          description={`The contact data of ${candidateIds.length} candidates will be
          exported to a CSV file.`}
          action={action}
          actionName="Export"
          permission={permission}
        >
          {trigger}
        </ConfirmationDialog>
      )}
    </>
  );
};
